export default __webpack_public_path__ + "static/media/krisi_xl.2718f8ef.jpg";